const calcular_resultados_finais_por_turma = [
  {
    path: "/calcular-resultados-finais-por-turma",
    name: "calcular_resultados_finais_por_turma",
    meta: {
      requireAuth: false,
      breadCrumb: "Processo de Resultado Final - Cálculo Resultados Finais",
    },
    component: () =>
      import(
        "@/views/CalcularResultadosFinaisPorTurmas/CalcularResultadosFinaisPorTurma.vue"
      ),
  },
];

export { calcular_resultados_finais_por_turma };
